import { useWallet } from '../use-wallet'

export const useConnectedWalletHistory = () => {
  const { wallets, disconnectWallet } = useWallet()
  const connectedWallet = Object.values(wallets)
    .filter((wallet) => wallet?.isConnected)
    .sort((a, b) => (+a.connectedAt > +b.connectedAt ? -1 : 1))
  const lastedConnectedWallet = connectedWallet[0]
  const firstConnectedWallet = connectedWallet[connectedWallet.length - 1]
  return { lastedConnectedWallet, disconnectWallet, firstConnectedWallet }
}
